<template>
  <div class="guide">
      <!-- 用户使用指南 -->
      
      <div  class="swiper">
          <!--  -->
            <el-collapse v-model="activeName" accordion @change="mainChange">
            <el-collapse-item title="如何上传需要切分处理的 PDF 文件？" name="1">
               <div>
                    <p class="remind" v-if="indexOne == 0">第一步：在文件管理页面中，点击“点击上传”按钮</p>
                    <p class="remind" v-if="indexOne == 1">第二步：点击“点击上传区域”</p>
                    <p class="remind" v-if="indexOne == 2">第三步：选择你要切分的文件，并点击“打开”按钮上传</p>
                    <p class="remind" v-if="indexOne == 3">第四步：选择是否翻译文件并点击“确认上传”按钮上传</p>
                </div>
                <div class="main1">
                    <div class="tdesign-demo-block--swiper-new" >
                        <!-- :style="{ width: '700px',height:'500px' }" -->
                        <t-swiper :navigation="{ placement: 'outside' }" @change="changeOne">
                            <t-swiper-item v-for="(item,index) in srcList " :key="'info1-'+index">
                                <div class="warp">
                                    <el-image class="img" :src="item" 
                                    :preview-src-list="srcList"></el-image>
                                </div>
                            </t-swiper-item>
                        </t-swiper> 
                    </div>
                </div>
            </el-collapse-item>
            <el-collapse-item title="如何查询 PDF 文件处理进度？" name="2">
                <div>
                    <p class="remind" v-if="indexTwo == 0">第一步：点击切分文件下的下拉框按钮</p>
                    <p class="remind" v-if="indexTwo == 1">第二步：查看文件处理进度</p>
                </div>
                <!-- changeTwo -->
                <div class="main1">
                    <div class="tdesign-demo-block--swiper-new" >
                        <!-- :style="{ width: '700px',height:'500px' }" -->
                        <t-swiper :navigation="{ placement: 'outside' }" @change="changeTwo">
                            <t-swiper-item v-for="(item,index) in srcImg " :key="'info2-'+index">
                                <div class="warp">
                                    <el-image class="img" :src="item" 
                                    :preview-src-list="srcImg"></el-image>
                                </div>
                            </t-swiper-item>
                        </t-swiper> 
                    </div>
                </div>
            </el-collapse-item>
            <el-collapse-item title="如何修改账号密码？" name="3">
               <div>
                    <p class="remind" v-if="indexThree == 0">第一步：点击账号头像</p>
                    <p class="remind" v-if="indexThree == 1">第二步：点击修改密码选项</p>
                    <p class="remind" v-if="indexThree == 2">第三步：输入旧密码后输入您要修改的新密码</p>
                    <p class="remind" v-if="indexThree == 3">第四步：点击”确认“按钮，修改密码</p>
                </div>
                <div class="main1">
                    <div class="tdesign-demo-block--swiper-new" >
                        <!-- :style="{ width: '700px',height:'500px' }" -->
                        <t-swiper :navigation="{ placement: 'outside' }" @change="changeThree">
                            <t-swiper-item v-for="(item,index) in srcThree " :key="'info3-'+index">
                                <div class="warp">
                                    <el-image class="img" :src="item" 
                                    :preview-src-list="srcThree"></el-image>
                                </div>
                            </t-swiper-item>
                        </t-swiper> 
                    </div>
                </div>
            </el-collapse-item>
            <el-collapse-item title="如何退出账号登录？" name="4">
                <div>
                    <p class="remind" v-if="indexfour == 0">第一步：点击账号头像</p>
                    <p class="remind" v-if="indexfour == 1">第二步：点击”退出登录“选项退出登录</p>
                    <p class="remind" v-if="indexfour == 2">第三步：点击确定</p>
                </div>
                <div class="main1">
                    <div class="tdesign-demo-block--swiper-new" >
                        <!-- :style="{ width: '700px',height:'500px' }" -->
                        <t-swiper :navigation="{ placement: 'outside' }" @change="changefour">
                            <t-swiper-item v-for="(item,index) in srcFour " :key="'info4-'+index">
                                <div class="warp">
                                    <el-image class="img" :src="item" 
                                    :preview-src-list="srcFour"></el-image>
                                </div>
                            </t-swiper-item>
                        </t-swiper> 
                    </div>
                </div>
            </el-collapse-item>
            <el-collapse-item title="如何调整PDF文件的显示条数？" name="5">
                <div>
                    <p class="remind" v-if="indexfive == 0">第一步：点击页码处的条目次数选择框</p>
                    <p class="remind" v-if="indexfive == 1">第二步：选择你想展示的条目次数</p>
                </div>
                <div class="main1">
                    <div class="tdesign-demo-block--swiper-new" >
                        <!-- :style="{ width: '700px',height:'500px' }" -->
                        <t-swiper :navigation="{ placement: 'outside',size: 'small'  }" @change="changefive">
                            <t-swiper-item v-for="(item,index) in srcFive " :key="'info5-'+index">
                                <div class="warp">
                                    <el-image class="img" :src="item" 
                                    :preview-src-list="srcFive"></el-image>
                                </div>
                            </t-swiper-item>
                        </t-swiper> 
                    </div>
                </div>
            </el-collapse-item>
            </el-collapse>
          
      </div>
  </div>
</template>

<script>
export default {
    name:"guide",
    data(){
        return{
            indexOne:0,//如何上传需要切分处理的PDF文件？
            indexTwo:0,//如何查询PDF文件处理进度？
            indexThree:0,//如何修改账号密码?
            indexfour:0,//如何退出账号登录？
            indexfive:0,
            activeName: '',// 默认展开
            role:localStorage.getItem("role"),
            srcList: [require('../../assets/user/1-1.png'),require('../../assets/user/1-2.png'),require('../../assets/user/1-3.png'),require('../../assets/user/1-4.png')],
            srcImg: [require('../../assets/user/2-1.png'),require('../../assets/user/2-2.png')],
            srcThree:[require('../../assets/user/3-1.png'),require('../../assets/user/3-2.png'),require('../../assets/user/3-3.png'),require('../../assets/user/3-4.png')],
            srcFour:[require('../../assets/user/4-1.png'),require('../../assets/user/4-2.png'),require('../../assets/user/4-3.png')],
            srcFive:[require('../../assets/user/5-1.png'),require('../../assets/user/5-2.png')]
        }
    },
    methods: {
        changeOne(current,context){
            this.indexOne = current
        },
        changeTwo(current,context){
            this.indexTwo = current
        },
        changeThree(current,context){
            this.indexThree = current
        },
        changefour(current,context){
            this.indexfour = current
        },
        changefive(current,context){
            this.indexfive = current
        },
        mainChange(activeNames){
            if(activeNames == 1){
                this.indexOne = 0
            }else if(activeNames == 2){
                this.indexTwo = 0
            }else if(activeNames == 3){
                this.indexThree = 0
            }else if(activeNames == 4){
                this.indexfour = 0
            }else if(activeNames == 5){
                this.indexfive = 0
            }
        }
        
    },
}
</script>
<style>
.el-image-viewer__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 5%;
}
.main1{
    width: 90%;
    margin: auto;
}
</style>
<style lang="scss" scoped>
::v-deep .el-collapse-item__header{
    font-size: 18px;
    // font-weight: 600;
    color: #333;
}
::v-deep .t-swiper__arrow--default .t-swiper__arrow-left {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    z-index: 2;
    background-color: rgba(130, 128, 128, 0);
    border: 1px solid ;
    color: rgb(0 0 0 / 55%);
    cursor: pointer;
    left: 16px;
}
::v-deep .t-swiper__arrow--default .t-swiper__arrow-right {
    position: absolute;
    top: 50%;
    border: 1px solid ;
    transform: translateY(-50%);
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    z-index: 2;
    background-color: rgba(130, 128, 128, 0);
    color: rgb(0 0 0 / 55%);
    cursor: pointer;
    right: 16px;
}
::v-deep .t-swiper__arrow-left{
    width: 35px !important;
    height: 35px !important;
    border-radius: 50% !important;
}
::v-deep .t-swiper__arrow-right{
    width: 35px !important;
    height: 35px !important;
    border-radius: 50% !important;
}
.remind{
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 700;
    margin-left:30px;
    margin-top: 10px;
    color: rgb(243, 9, 9);
}
.warp{
    position: relative;
    background: rgba(0,0,0,.5);
    width: 100%;
    min-height: 650px;
    // height: 700px;
}
.guide{
    padding:20px;
    background-color: white;
    // min-height: 1000px;
}
.t-swiper {
    // position: relative;
    // width: 100%;
    // height: 700px;
}
.img{
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>